/**
 * @author caijianjia
 * @date 2020/9/27 11:10 上午
 */

import request from '../config/network/requestUcenterApiService'

// --------------------表单分类开始------------------------------
/**
 * 题库
 */

// 获取学科列表
export function querySubjects () {
    return request({
        url: 'api/questions/subjects',
        method: 'get'
    })
}

// 获取年级列表
export function queryGrades () {
    return request({
        url: 'api/questions/grades',
        method: 'get'
    })
}

// 获取题型分类
export function queryTypes ({
    subject_id,
    grade_id
}) {
    let url = 'api/questions/types'
    const params = {}
    if(subject_id) params['equal[subject_id]'] = subject_id
    if(grade_id) params.grade_id = grade_id
    return request({
        url,
        method: 'get',
        params
    })
}

// 获取题库列表
export function queryQuestions ({
    subject_id,
    grade_id,
    chapter_id,
    knowledge_id,
    question_type,
    difficulty,
    content,
    page,
    per_page
}) {
    const params = {}
    if(subject_id) params['equal[question.subject_id]'] = subject_id
    if(grade_id) params['equal[question.grade_id]'] = grade_id
    if(chapter_id && chapter_id!=='all') params['equal[question.chapter_id]'] = chapter_id
    if(knowledge_id && knowledge_id!=='all') params['equal[question.knowledge_id]'] = knowledge_id
    if(question_type) params['equal[question.question_type]'] = question_type
    if(difficulty) params['equal[question.difficulty]'] = difficulty
    if(content) params['like[question.detail.content]'] = content
    if(page) params['page'] = page
    if(per_page) params['per_page'] = per_page
    return request({
        url: 'api/questions',
        method: 'get',
        params
    })
}

// 获取出版社列表
export function queryPublishers ({
    subject_id,
    grade_id
}) {
    const params = {}
    if(subject_id) params['equal[unit.subject_id]'] = subject_id
    if(grade_id) params['grade_id'] = grade_id
    return request({
        url: 'api/questions/publishers',
        method: 'get',
        params
    })
}

// 获取书名列表
export function queryBooks({
   subject_id,
   grade_id,
   publisher_id
}){
    const params = {}
    if(subject_id) params['subject_id'] = subject_id
    if(grade_id) params['equal[grade_id]'] = grade_id
    if(publisher_id) params['equal[publisher_id]'] = publisher_id
    return request({
        url: `api/questions/books?subject_id=${subject_id}`,
        method: 'get',
        params
    })
}

// 获取单元列表
export function queryUnits ({
    subject_id,
    pub_id,
    with_chapters
}) {
    const params = {}
    if(subject_id) params['equal[subject_id]'] = subject_id
    if(pub_id) params['equal[pub_id]'] = pub_id
    if(with_chapters) params['with_chapters'] = with_chapters
    return request({
        url: 'api/questions/units',
        method: 'get',
        params
    })
}

// 获取知识点列表
export function queryKnowledge ({
    subject_id,
    grade_id
}) {
    const params = {}
    if(subject_id) params['equal[subject_id]'] = subject_id
    if(grade_id) params['equal[grade_id]'] = grade_id
    return request({
        url: 'api/questions/knowledge',
        method: 'get',
        params
    })
}

// 更新题库访问次数
export function updateQuestion ({
    id
}) {
    return request({
        url: `api/questions/${id}`,
        method: 'patch',
        data: {
            used_number:'+1'
        }
    })
}

// 错误反馈
export function updateErrorReport ({
   question_id,
   subject_id,
   grade_id,
   feedback,
   question = 0,
   answer = 0,
   analyze = 0,
   other = 0
}) {
    return request({
        url: `api/questions/error_report`,
        method: 'post',
        data: {
            question_id,
            subject_id,
            grade_id,
            feedback,
            error_areas: {
                question,
                answer,
                analyze,
                other
            }
        }
    })
}

// 学科切换
export function updateSelectedSubject ({
   subject_id,
   grade_id
}) {
    return request({
        url: `api/questions/subject_switch_log`,
        method: 'post',
        data: {
            subject_id,
            grade_id
        }
    })
}

// 获取当前选中学科
export function querySelectedSubject () {
    return request({
        url: 'api/questions/subject_switch_log',
        method: 'get'
    })
}
